import { useQuery } from '@apollo/client'
import {
  optionalEnrollmentId,
  OptionalEnrollmentId,
} from '@utils/optionalEnrollmentId'
import { ILesson } from '@dtos/Course'
import { GET_COURSE_CONTENT } from './queries/getCourseContent'

interface IGetCourseContentProps {
  id: number
  courseId: number
  /** Ausente na visão do produtor: não existe matrícula. */
  enrollmentId?: OptionalEnrollmentId
  enabled?: boolean
}

interface IGetCourseContentResponse {
  courseContent: {
    lesson: ILesson
  }
}

export const useGetCourseContent = ({
  id,
  courseId,
  enrollmentId,
  enabled = true,
}: IGetCourseContentProps) => {
  const { data, loading, error } = useQuery<IGetCourseContentResponse>(
    GET_COURSE_CONTENT,
    {
      variables: {
        id,
        courseId,
        enrollmentId: optionalEnrollmentId(enrollmentId),
      },
      skip: !enabled,
      fetchPolicy: 'cache-and-network',
    },
  )

  return { data, loading, error }
}
